'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    dataGridHeaderCellClassNames: function() {
        return dataGridHeaderCellClassNames;
    },
    useDataGridHeaderCellStyles_unstable: function() {
        return useDataGridHeaderCellStyles_unstable;
    }
});
const _react = require("@griffel/react");
const _useTableHeaderCellStylesstyles = require("../TableHeaderCell/useTableHeaderCellStyles.styles");
const dataGridHeaderCellClassNames = {
    root: 'fui-DataGridHeaderCell',
    button: 'fui-DataGridHeaderCell__button',
    sortIcon: 'fui-DataGridHeaderCell__sortIcon',
    aside: 'fui-DataGridHeaderCell__aside'
};
const useDataGridHeaderCellStyles_unstable = (state)=>{
    'use no memo';
    (0, _useTableHeaderCellStylesstyles.useTableHeaderCellStyles_unstable)(state);
    state.root.className = (0, _react.mergeClasses)(dataGridHeaderCellClassNames.root, state.root.className);
    if (state.button) {
        state.button.className = (0, _react.mergeClasses)(dataGridHeaderCellClassNames.button, state.button.className);
    }
    if (state.sortIcon) {
        state.sortIcon.className = (0, _react.mergeClasses)(dataGridHeaderCellClassNames.sortIcon, state.sortIcon.className);
    }
    if (state.aside) {
        state.aside.className = (0, _react.mergeClasses)(dataGridHeaderCellClassNames.aside, state.aside.className);
    }
    return state;
};
